<template>
  <div style="padding: 30px 0" class="withdraw-tab">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col
            ><span style="height:25px;border-left:3px solid #35B5FE;"></span
          ></a-col>
          <a-col><b>回款记录</b></a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start" style="padding:0 40px">
      <a-col span="24">
        <a-row type="flex" justify="space-between">
          <a-col>
            <p>
              offer金额：<a><b>4000，000</b></a>
            </p>
            <p>
              应收回款：<a><b>4000，000</b></a>
            </p>
          </a-col>
          <a-col>
            <a-button type="primary" icon="plus" @click="$emit('addCash')"
              >添加回款</a-button
            >
          </a-col>
        </a-row>
        <a-row class="table head">
          <a-col span="6" class="span">项目</a-col>
          <a-col span="6" class="span">回款金额/元</a-col>
          <a-col span="6" class="span">回款时间</a-col>
          <a-col span="6" class="span">操作人</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="6" class="span">第一次回款</a-col>
          <a-col span="6" class="span">50,5000</a-col>
          <a-col span="6" class="span">2019-5-20</a-col>
          <a-col span="6" class="span">撒打发</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="6" class="span">第二次回款</a-col>
          <a-col span="6" class="span">50,5000</a-col>
          <a-col span="6" class="span">2019-5-20</a-col>
          <a-col span="6" class="span">撒打发</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="6" class="span">合计回款</a-col>
          <a-col span="6" class="span">50,5000</a-col>
          <a-col span="6" class="span">---</a-col>
          <a-col span="6" class="span">---</a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row type="flex" justify="space-between" style="margin:60px 0 15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col
            ><span style="height:25px;border-left:3px solid #35B5FE;"></span
          ></a-col>
          <a-col><b>佣金分配</b></a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start" style="padding:0 40px">
      <a-col span="24">
        <a-row type="flex" justify="space-between">
          <a-col span="12"><p>已收回款：1000，000</p></a-col>
          <a-col span="12"><p>应分佣金：1000，000</p></a-col>
          <a-col span="12"> <p>待分佣金：1000，000</p></a-col>
          <a-col span="12"><p>已分佣金：1000，000</p></a-col>
        </a-row>
      </a-col>
      <p style="padding-top:20px"><b>做单-各级分佣</b></p>
      <a-col span="24">
        <a-row class="table head">
          <a-col span="3" class="span">项目</a-col>
          <a-col span="3" class="span">做单</a-col>
          <a-col span="3" class="span">成员</a-col>
          <a-col span="3" class="span">团队长-黄金</a-col>
          <a-col span="3" class="span">团队长-白金</a-col>
          <a-col span="3" class="span">团队长-黑金</a-col>
          <a-col span="3" class="span">合计分佣</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">分佣人</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">---</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">分佣比例</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">分佣金额</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">结算</a-col>
          <a-col span="3" class="span"
            ><span style="color: rgb(66, 185, 131);">已结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color: rgb(66, 185, 131);">已结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color: rgb(66, 185, 131);">已结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color:red;">未结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color:red;">未结算</span></a-col
          >
          <a-col span="3" class="span">---</a-col>
        </a-row>
      </a-col>
      <p style="padding-top:20px"><b>职位-各级分佣</b></p>
      <a-col span="24">
        <a-row class="table head">
          <a-col span="3" class="span">项目</a-col>
          <a-col span="3" class="span">做单</a-col>
          <a-col span="3" class="span">成员</a-col>
          <a-col span="3" class="span">团队长-黄金</a-col>
          <a-col span="3" class="span">团队长-白金</a-col>
          <a-col span="3" class="span">团队长-黑金</a-col>
          <a-col span="3" class="span">合计分佣</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">分佣人</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">张继强</a-col>
          <a-col span="3" class="span">---</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">分佣比例</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
          <a-col span="3" class="span">38%</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">分佣金额</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
          <a-col span="3" class="span">380，000</a-col>
        </a-row>
        <a-row class="table">
          <a-col span="3" class="span">结算</a-col>
          <a-col span="3" class="span"
            ><span style="color: rgb(66, 185, 131);">已结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color: rgb(66, 185, 131);">已结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color: rgb(66, 185, 131);">已结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color:red;">未结算</span></a-col
          >
          <a-col span="3" class="span"
            ><span style="color:red;">未结算</span></a-col
          >
          <a-col span="3" class="span">---</a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Withdraw"
};
</script>
<style lang="scss">
.withdraw-tab {
  .table {
    &.head {
      .span {
        background: #e6e6e6;
      }
    }
    text-align: center;
    .span {
      border: 1px solid #aeaeae;
      line-height: 2.5;
      &:not(:last-child) {
        border-right: none;
      }
    }
    &:not(:last-child) {
      .span {
        border-bottom: none;
      }
    }
  }
}
</style>
